import { useCallback, useState } from 'react';

interface IUseSelectedItemsProps<T> {
  items: T[];
}

interface IReturn<T> {
  selectedItems: T[];
  toggleItem: (itemId: T) => void;
  toggleAll: () => void;
  clearSelection: () => void;
}

export const useSelectedItems = <T,>({ items }: IUseSelectedItemsProps<T>): IReturn<T> => {
  const [selectedItems, setSelectedItems] = useState<T[]>([]);

  const toggleItem = useCallback(
    (itemId: T) => {
      setSelectedItems(selected => {
        const isSelected = selectedItems.some(selected => selected === itemId);
        if (isSelected) return selectedItems.filter(selected => selected !== itemId);
        return [...selected, itemId];
      });
    },
    [selectedItems],
  );

  const toggleAll = useCallback(() => {
    setSelectedItems(selected => {
      if (selected.length === items.length) return [];
      return items;
    });
  }, [items]);

  const clearSelection = useCallback(() => setSelectedItems([]), []);

  return {
    selectedItems,
    toggleItem,
    toggleAll,
    clearSelection,
  };
};
